export const formatDuration = (minutes: number): string => {
  if (minutes < 1) {
    return "< 1m";
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = Math.floor(minutes % 60);

  if (hours === 0) {
    return `${remainingMinutes}m`;
  }

  if (remainingMinutes === 0) {
    return `${hours}h`;
  }

  return `${hours}h ${remainingMinutes}m`;
};

export const formatNumber = (num: number): string => {
  return new Intl.NumberFormat("en-US").format(num);
};

const USD_CENT_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const USD_PRECISE_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 6,
});

/**
 * Format a USD dollar amount. Use "precise" for sub-cent amounts
 * (per-completion cost can be fractions of a cent); the formatter trims
 * trailing zeros down to 2 decimals when the value rounds cleanly.
 */
export const formatUSD = (amount: number, precision: "cents" | "precise" = "precise"): string => {
  if (!Number.isFinite(amount)) return "—";
  const formatter = precision === "cents" ? USD_CENT_FORMATTER : USD_PRECISE_FORMATTER;
  return formatter.format(amount);
};
